'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

inputValueDirective.$inject = ['$log', '$timeout'];


var _module = _angular2.default.module('cb.ui-components.form.input-value', []);

_module.directive('input', inputValueDirective);

exports.default = _module;


function inputValueDirective($log, $timeout) {
    return {
        restrict: 'C', // restrict to .input
        require: ['?ngModel'],
        link: postLink
    };

    function postLink(scope, element, attr, ctrls) {
        var hasNgModel = !!ctrls[0];
        var ngModelCtrl = ctrls[0] || fakeNgModel();
        var tagName = element[0].tagName.toLowerCase();

        if (attr.type === 'hidden') {
            element.attr('aria-hidden', 'true');
            return;
        }

        if (tagName === 'input' || tagName === 'select') {
            element.on('input', inputCheckValue);
            element.on('change', inputCheckValue);
            element.on('blur', inputCheckValue);
        } else {
            return;
        }

        if (!hasNgModel) {
            inputCheckValue();
        }

        // When the developer uses the ngValue directive for the input, we have to observe the attribute, because
        // AngularJS's ngValue directive is just setting the `value` attribute.
        if (attr.ngValue) {
            attr.$observe('value', inputCheckValue);
        }

        ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
        ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);

        // Gets run through ngModel's pipeline and set the `is-empty` class
        function ngModelPipelineCheckValue(arg) {
            setIsEmpty(ngModelCtrl.$isEmpty(arg));
            return arg;
        }

        function inputCheckValue() {
            var isEmpty = typeof element.val() !== 'undefined' && element.val().length === 0;

            setIsEmpty(isEmpty);

            if (tagName === 'select') {
                selectCheckValue();
            }
        }

        function selectCheckValue() {
            if (typeof element.val() !== 'undefined' && element.val().length === 0) {
                if (element[0].options.length > 0 && element[0].options[element[0].selectedIndex].text.length > 0) {
                    setIsEmpty(false);
                }
            }
        }

        function setIsEmpty(isEmpty) {
            return isEmpty ? element.addClass('is-empty') : element.removeClass('is-empty');
        }
    }

    function fakeNgModel() {
        return {
            $fake: true,
            $setTouched: _angular2.default.noop,
            $setViewValue: function $setViewValue(value) {
                this.$viewValue = value;
                this.$render(value);
                this.$viewChangeListeners.forEach(function (cb) {
                    cb();
                });
            },
            $isEmpty: function $isEmpty(value) {
                return ('' + value).length === 0;
            },
            $parsers: [],
            $formatters: [],
            $viewChangeListeners: [],
            $render: _angular2.default.noop
        };
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/form/input-value.directive.js
// module id = 888
// module chunks = 0